(() => {
  const roots = document.querySelectorAll('[data-product-context]');
  if (!roots.length) return;

  function parseSameOrigin(value) {
    if (!value) return null;
    try {
      const url = new URL(value, window.location.origin);
      return url.origin === window.location.origin ? url : null;
    } catch {
      return null;
    }
  }

  function isResultsUrl(url) {
    const segments = url.pathname.split('/').filter(Boolean);
    const routeIndex = segments[0] === 'collections' || segments[0] === 'search'
      ? 0
      : /^[a-z]{2}(?:-[a-z]{2})?$/i.test(segments[0] || '')
        ? 1
        : -1;
    if (routeIndex < 0) return false;
    if (segments[routeIndex] === 'search') return segments.length === routeIndex + 1;
    return segments[routeIndex] === 'collections'
      && segments.length >= routeIndex + 2
      && segments.length <= routeIndex + 3
      && segments[routeIndex + 2] !== 'products';
  }

  roots.forEach(root => {
    const returnLink = root.querySelector('[data-product-context-return]');
    const returnLabel = root.querySelector('[data-product-context-return-label]');
    if (!(returnLink instanceof HTMLAnchorElement) || !returnLabel) return;

    const referrerUrl = parseSameOrigin(document.referrer);
    if (!referrerUrl || !isResultsUrl(referrerUrl)) return;

    returnLink.href = `${referrerUrl.pathname}${referrerUrl.search}${referrerUrl.hash}`;
    returnLabel.textContent = referrerUrl.pathname.split('/').filter(Boolean).at(-1) === 'search'
      ? 'Back to search results'
      : 'Back to your product results';
  });
})();
